import { create } from 'zustand';
import type { ReportContextShape, DateRangeShape } from './reportContextTypes';

export interface ReportContextStore extends ReportContextShape {
  setProject: (projectId: string | null, projectName: string | null) => void;
  setExecutionId: (executionId: string | null) => void;
  setDateRange: (dateRange: DateRangeShape | null) => void;
  setTimezone: (timezone: string | null) => void;
  setSource: (source: string | null) => void;
  setLastRefreshAt: (lastRefreshAt: string | null) => void;
  setStale: (stale: boolean) => void;
  /** Batch update for Reports workspace sync. */
  setReportContext: (partial: Partial<ReportContextShape>) => void;
  reset: () => void;
}

const initialState: ReportContextShape = {
  projectId: null,
  projectName: null,
  executionId: null,
  dateRange: null,
  timezone: null,
  source: null,
  lastRefreshAt: null,
  stale: false,
};

export const useReportContextStore = create<ReportContextStore>((set) => ({
  ...initialState,

  setProject: (projectId, projectName) =>
    set({ projectId, projectName }),

  setExecutionId: (executionId) =>
    set({ executionId }),

  setDateRange: (dateRange) =>
    set({ dateRange }),

  setTimezone: (timezone) =>
    set({ timezone }),

  setSource: (source) =>
    set({ source }),

  setLastRefreshAt: (lastRefreshAt) =>
    set({ lastRefreshAt }),

  setStale: (stale) =>
    set({ stale }),

  setReportContext: (partial) =>
    set((state) => ({ ...state, ...partial })),

  reset: () =>
    set(initialState),
}));
